<template>
  <svg viewBox="0 0 100 100" style="overflow: visible !important">
    <rect
      width="100%"
      height="100%"
      :fill="background"
      stroke-width="0.5"
      :stroke="highlighted()"
    />
    <text x="40" y="52" fill="#e2e2e2" font-size="0.6rem" font-weight="normal">
      NFT
    </text>
  </svg>
</template>

<script>
export default {
  props: ['highlight', 'background'],
  methods: {
    highlighted() {
      return this.highlight ? '#009fb1' : '#e2e2e2';
    },
  },
};
</script>
